module.exports = __webpack_public_path__ + "static/media/2.fcb7709b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/soligorsk/2.jpg
// module id = 541
// module chunks = 0